// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1qerd","headerWrapper":"Header_headerWrapper__bZwrJ","content":"Header_content__26roL","error":"Header_error__30wxi"};